export default __webpack_public_path__ + "static/media/aviso.6356b5ee.svg";